export default "__VITE_PUBLIC_ASSET__ddf63641__"